import { put, select } from "redux-saga/effects";
import { API } from 'aws-amplify';
import { getResponseData } from '../../utils/apiHelpers';

import moment from "moment";

import * as actions from "../actions";
import * as selectors from "../selectors/selectors";
import { handleApiError } from '../../utils/apiErrorHandler';

function* kryKultivars(seisoen) {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/kultivars?seisoen=${seisoen}`;
        const response = yield API.get(apiName, path, { response: true });
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            throw new Error({
                error: {},
                easymessage: "Iets het skeefgeloop...",
                status: 404,
                message: "Die kultivars kon nie gevind word nie."
            });
        } else {
            return getResponseData(response, []);
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        throw {
            error: errordata,
            easymessage: "Iets het skeefgeloop...",
            status: errordata.code,
            message: errordata.message
        };
    }
}

export function* getKultivarsSaga_Plukbepl(action) {
    try {
        const results = yield* kryKultivars(action.seisoen);
        yield put(actions.setPlukbeplanKultivars(results));
    } catch (error) {
        console.log(error);
        yield put(actions.setPlukbeplanKultivarsFailed(error));
    }
    try {
        const opstellings_results = yield* kryOpstellings();
        yield put(actions.setPlukbeplanOpstellings(opstellings_results));
    } catch (error) {
        console.log(error);
        yield put(actions.setPlukbeplanOpstellingsFailed(error));
    }
}

function* kryWeek(jaar, week, kultivar) {
    try {
        let apiName = 'API_Pluk';
        let path = `/plukbeplanner/week?jaar=${jaar}&week=${week}${kultivar ? "&kultivar=" + kultivar : ""}`;
        const response = yield API.get(apiName, path, { response: true });
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            return [];
        } else {
            return getResponseData(response, []);
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        throw {
            error: errordata,
            easymessage: "Iets het skeefgeloop...",
            status: errordata.code,
            message: errordata.message
        };
    }
}

function* kryDag(jaar, week, dag, kultivar) {
    try {
        let apiName = 'API_Pluk';
        let path = `/plukbeplanner/dag?jaar=${jaar}&week=${week}${dag ? "&dag=" + dag : ""}${kultivar ? "&kultivar=" + kultivar : ""}`;
        const response = yield API.get(apiName, path, { response: true });
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            return [];
        } else {
            return getResponseData(response, []);
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        throw {
            error: errordata,
            easymessage: "Iets het skeefgeloop...",
            status: errordata.code,
            message: errordata.message
        };
    }
}

function* kryDagItems(jaar, week, dag, kultivar) {
    try {
        let apiName = 'API_Pluk';
        let path = `/plukbeplanner/item?jaar=${jaar}&week=${week}${dag ? "&dag=" + dag : ""}${kultivar ? "&kultivar=" + kultivar : ""}`;
        const response = yield API.get(apiName, path, { response: true });
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            return [];
        } else {
            return getResponseData(response, []);
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        throw {
            error: errordata,
            easymessage: "Iets het skeefgeloop...",
            status: errordata.code,
            message: errordata.message
        };
    }
}

function* kryOpstellings() {
    try {
        let apiName = 'API_Pluk';
        let path = `/plukbeplanner/opstellings`;
        const response = yield API.get(apiName, path, { response: true });
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            return [];
        } else {
            return getResponseData(response, []);
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        throw {
            error: errordata,
            easymessage: "Iets het skeefgeloop...",
            status: errordata.code,
            message: errordata.message
        };
    }
}

export function* getWeekSaga_Plukbepl(action) {
    try {
        const weekresults = yield* kryWeek(action.jaar, action.week);
        const daeresults = yield* kryDag(action.jaar, action.week);
        const daeitemsresults = yield* kryDagItems(action.jaar, action.week);
        yield put(actions.setPlukbeplanWeek(weekresults, daeresults, daeitemsresults));
    } catch (error) {
        console.log(error);
        yield put(actions.setPlukbeplanWeekFailed(error));
    }
}

export function* getWeekDaeSaga_Plukbepl(action) {
    try {
        const results = yield* kryDag(action.jaar, action.week);
        yield put(actions.setPlukbeplanWeekDae(results));
    } catch (error) {
        console.log(error);
        yield put(actions.setPlukbeplanWeekDaeFailed(error));
    }
}

export function* getOpstellingsSaga_Plukbepl(action) {
    try {
        const results = yield* kryOpstellings();
        yield put(actions.setPlukbeplanOpstellings(results));
    } catch (error) {
        console.log(error);
        yield put(actions.setPlukbeplanOpstellingsFailed(error));
    }
}

export function* setWeekBeginPlukbeplanSaga(action) {
    try {
        let body = {
            kategorie: "PLUK_BEPLANWEEKBEGIN",
            dag: action.dag
        };
        let apiName = 'AWSApiGateway';
        let myInit = {
            response: true,
            body: body
        }
        if (action.id) {
            let path = `/opstellings/PLUK?kategorie=PLUK_BEPLANWEEKBEGIN&id=${encodeURIComponent(action.id)}`;
            yield API.put(apiName, path, myInit);
        } else {
            let path = `/opstellings/PLUK`;
            yield API.post(apiName, path, myInit);
        }
        yield put(actions.setPlukbeplanOpstellingsSnackbarSuccess());
        yield put(actions.getPlukbeplanOpstellings());
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.setPlukbeplanOpstellingsSnackbarFailed(errordata, "'n Opstelling kon nie gemaak word nie.", errordata.code, errordata.message));
    }
}

export function* setViewEenheidPlukbeplanSaga(action) {
    try {
        let body = {
            kategorie: "PLUK_BEPLANVIEWEENHEID",
            eenheid: action.eenheid
        };
        let apiName = 'AWSApiGateway';
        let myInit = {
            response: true,
            body: body
        }
        if (action.id) {
            let path = `/opstellings/PLUK?kategorie=PLUK_BEPLANVIEWEENHEID&id=${encodeURIComponent(action.id)}`;
            yield API.put(apiName, path, myInit);
        } else {
            let path = `/opstellings/PLUK`;
            yield API.post(apiName, path, myInit);
        }
        yield put(actions.setPlukbeplanOpstellingsSnackbarSuccess());
        yield put(actions.getPlukbeplanOpstellings());
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.setPlukbeplanOpstellingsSnackbarFailed(errordata, "'n Opstelling kon nie gemaak word nie.", errordata.code, errordata.message));
    }
}

export function* getWeekTeikenSaga_Plukbepl(action) {
    try {
        const weekresults = yield* kryWeek(action.jaar, action.week, action.kultivar);
        yield put(actions.setPlukbeplanWeekTeiken(action.kultivar, action.week, weekresults.length > 0 ? weekresults[0] : null));
    } catch (error) {
        console.log(error);
    }
}

export function* getDagTeikenSaga_Plukbepl(action) {
    try {
        const dagresults = yield* kryDag(action.jaar, action.week, action.dag, action.kultivar);
        yield put(actions.setPlukbeplanDagTeiken(action.kultivar, action.week, action.dag, dagresults.length > 0 ? dagresults[0] : null));
    } catch (error) {
        console.log(error);
    }
}

export function* getDagItemSaga_Plukbepl(action) {
    try {
        const dagresults = yield* kryDagItems(action.jaar, action.week, action.dag, action.kultivar);
        yield put(actions.setPlukbeplanDagItem(action.kultivar, action.week, action.dag, dagresults.length > 0 ? dagresults : null));
    } catch (error) {
        console.log(error);
    }
}